import React, { Component } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { CustomFilterDateSearch, CustomFilterField } from '../../../domain/ui/FilterDomains';
import Icon from 'icons/Icon';
import { FormicaTimePickerDate } from '../custom-time-picker/TimePickerDomain';
import DateFilterComponent from '../custom-time-picker/DateFilterComponent';
import CustomDismissible from '../CustomDismissible';

class CustomFilterDateComponent extends Component<Props> {
  private dateOverlayPanel: OverlayPanel | null = null;

  public render() {
    const { field, id, roundVisible, onRemove, onToggle } = this.props;
    return (
      <CustomDismissible id={id} onDismiss={() => this.dateOverlayPanel?.hide()}>
        <div id={id}>
          <OverlayPanel appendTo='self' ref={(r) => (this.dateOverlayPanel = r)}>
            <DateFilterComponent
              startDate={(field.search.value as CustomFilterDateSearch).startDate}
              endDate={(field.search.value as CustomFilterDateSearch).endDate}
              onApply={this.applyFilter}
              roundVisible={roundVisible}
              selectType={'DEFAULT'}
              onChangeStartDate={this.onChangeStartDate}
              onChangeEndDate={this.onChangeEndDate}
            />
          </OverlayPanel>
          <div
            className={`inline-flex shrink-0 items-center h-[32px]  border-[1px]  bg-[#458EF714] rounded-[4px] box-border text-[#458EF7] border-[#458EF7] ${field.enabled ? '' : 'opacity-40'}`}
          >
            <div
              className='flex w-full gap-x-1 z-10 px-2'
              id={`filter-toggle-${id}`}
              onClick={(e) => {
                this.dateOverlayPanel?.toggle(e, e.currentTarget);
              }}
            >
              <p className={'flex items-center shrink-0 font-semibold'}>{field.label}</p>
              <p className={'flex items-center shrink-0'}>:</p>
              <p className={'flex items-center shrink-0'}>{this.getDate()}</p>
            </div>
            <div className={'flex cursor-pointer shrink-0 '}>
              <Icon size={20} onClick={onToggle} className={'opacity-80 hover:opacity-100'} icon={field.enabled ? 'visibility' : 'visibility_off'} />
            </div>
            <div className={'flex cursor-pointer shrink-0'}>
              <Icon size={20} onClick={onRemove} className={'opacity-80 hover:opacity-100'} icon={'close'} />
            </div>
          </div>
        </div>
      </CustomDismissible>
    );
  }

  private onChangeStartDate = (startDate: FormicaTimePickerDate) => {
    const { field, onChange } = this.props;
    (field.search.value as CustomFilterDateSearch).startDate = startDate;
    onChange();
  };

  private onChangeEndDate = (endDate: FormicaTimePickerDate) => {
    const { field, onChange } = this.props;
    (field.search.value as CustomFilterDateSearch).endDate = endDate;
    onChange();
  };

  private applyFilter = () => {
    const { onApply } = this.props;
    onApply();
    this.dateOverlayPanel?.hide();
  };

  private getDate = () => {
    const { field } = this.props;
    const startDate = (field.search.value as CustomFilterDateSearch).startDate;
    const endDate = (field.search.value as CustomFilterDateSearch).endDate;
    return `${startDate.label} > ${endDate.label}`;
  };
}

interface Props {
  id: string;
  field: CustomFilterField;
  onChange: () => void;
  onApply: () => void;
  onRemove: () => void;
  onToggle: () => void;
  roundVisible?: boolean;
}

export default CustomFilterDateComponent;
